import env from 'env';
import { IConfig } from '@onlyoffice/document-editor-react';
import { FILE_TYPES } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';

export const DOCUMENT_TYPE = {
  [FILE_TYPES.DOCUMENT_XLS]: 'cell',
  [FILE_TYPES.DOCUMENT_XLSX]: 'cell',
  [FILE_TYPES.DOCUMENT_CSV]: 'cell',
  [FILE_TYPES.DOCUMENT_PPT]: 'slide',
  [FILE_TYPES.DOCUMENT_PPTX]: 'slide',
  [FILE_TYPES.DOCUMENT_DOC]: 'word',
  [FILE_TYPES.DOCUMENT_DOCX]: 'word',
} as Record<string, string>;

export const FILE_TYPE = {
  [FILE_TYPES.DOCUMENT_XLS]: 'xls',
  [FILE_TYPES.DOCUMENT_XLSX]: 'xlsx',
  [FILE_TYPES.DOCUMENT_CSV]: 'csv',
  [FILE_TYPES.DOCUMENT_PPT]: 'ppt',
  [FILE_TYPES.DOCUMENT_PPTX]: 'pptx',
  [FILE_TYPES.DOCUMENT_DOC]: 'doc',
  [FILE_TYPES.DOCUMENT_DOCX]: 'docx',
} as Record<string, string>;

export const EDITOR_CONFIG: IConfig['editorConfig'] = {
  mode: 'view',
  user: {
    id: 'viewer',
    name: 'Viewer',
  },
  customization: {
    compactHeader: true,
    plugins: false,
    help: false,
    chat: false,
    comments: false,
    commentAuthorOnly: false,
    autosave: false,
    forcesave: false,
    feedback: false,
    toolbarHideFileName: true,
    hideRightMenu: true,
    hideNotes: true,
    compactToolbar: true,
    toolbarNoTabs: true,
    spellcheck: false,
    submitForm: false,
    review: {
      trackChanges: false,
      showReviewChanges: false,
    },
  },
};

export const PERMISSIONS: IConfig['document']['permissions'] = {
  edit: false,
  print: false,
  download: false,
  chat: false,
  comment: false,
  copy: false,
  deleteCommentAuthorOnly: false,
  editCommentAuthorOnly: false,
  fillForms: false,
  modifyContentControl: false,
  modifyFilter: false,
  protect: true,
  rename: false,
  review: false,
};

export const SERVER_URL = env.ONLYOFFICE_URL;
